export default function () {
	if (!window.showAlert) {
		document.getElementById('alert').classList.add('active');
		document.querySelector('html').style.overflow = 'hidden';
		document.querySelector('.app').style.pointerEvents = 'none';
		window.showAlert = true;
	}
}
